"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useAuth } from "@/components/AuthProvider";

const links = [
  { href: "/", label: "Accueil" },
  { href: "/prepa", label: "Sideboard" },
  { href: "/decks", label: "Decks" },
  { href: "/inventaire", label: "Inventaire" },
  { href: "/galerie", label: "Galerie" },
  { href: "/game", label: "Jouer" },
];

export default function Nav() {
  const pathname = usePathname();
  const { user, loading, syncing } = useAuth();
  const compact = pathname.startsWith("/prepa");

  return (
    <header className="sticky top-0 z-50 border-b border-white/5 bg-[#060611]/80 backdrop-blur-xl">
      <div
        className={`mx-auto flex h-12 items-center justify-between gap-3 px-3 sm:h-14 sm:px-6 ${
          compact ? "max-w-none" : "max-w-7xl"
        }`}
      >
        <Link href="/" className="flex shrink-0 items-center gap-2 group">
          <div className="relative">
            <div className="absolute inset-0 rounded-lg bg-gradient-to-r from-emerald-500 to-cyan-500 opacity-40 blur-md group-hover:opacity-70 transition" />
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src="/rifthub-logo.png"
              alt="RiftHub"
              className="relative h-8 w-8 object-contain sm:h-9 sm:w-9"
            />
          </div>
          {!compact && (
            <span className="hidden text-lg font-black tracking-tight sm:inline">
              <span className="bg-gradient-to-r from-emerald-400 via-cyan-400 to-blue-400 bg-clip-text text-transparent">
                RiftHub
              </span>
            </span>
          )}
        </Link>

        <nav className="flex min-w-0 items-center gap-0.5 overflow-x-auto sm:gap-1">
          {links.map((link) => {
            const active =
              link.href === "/"
                ? pathname === "/"
                : pathname.startsWith(link.href) ||
                  (link.href === "/inventaire" && pathname.startsWith("/collection"));
            return (
              <Link
                key={link.href}
                href={link.href}
                className={`shrink-0 rounded-xl px-2 py-1.5 text-xs font-medium transition sm:px-3 sm:text-sm ${
                  active
                    ? link.href === "/prepa"
                      ? "bg-emerald-600/30 text-emerald-100"
                      : "bg-white/10 text-white"
                    : "text-gray-400 hover:bg-white/5 hover:text-white"
                }`}
              >
                {link.label}
              </Link>
            );
          })}
          <Link
            href="/compte"
            className={`ml-0.5 shrink-0 rounded-xl px-2 py-1.5 text-xs font-medium transition sm:ml-1 sm:px-3 sm:text-sm ${
              pathname.startsWith("/compte")
                ? "bg-cyan-600/30 text-cyan-200"
                : user
                  ? "text-cyan-300/90 hover:bg-cyan-500/10"
                  : "text-gray-400 hover:bg-white/5 hover:text-white"
            }`}
            title={user?.email ?? "Compte"}
          >
            {loading ? "…" : syncing ? "Sync…" : "Compte"}
          </Link>
        </nav>
      </div>
    </header>
  );
}
